import { render, staticRenderFns } from "./CommunityWorkNewsCard.vue?vue&type=template&id=e4c54568&scoped=true"
import script from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
export * from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityWorkNewsCard.vue?vue&type=style&index=0&id=e4c54568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c54568",
  null
  
)

export default component.exports